import {
    GET_ALL_REPORTS,
    GET_REPORT_TYPES,
    GET_REPORT_KEYS,
    SET_MONTH,
    SET_TO_MONTH,
    SET_YEAR,
    SET_REPORT_TYPE,
    GET_JOBPACK_REPORTS,
    GET_HSQE_TEMPLATE,
    SET_SPECIFIC_TEMPLATE,
    GET_VEHICLE_ALERTS,
    GET_DOWNLOADS,

} from "./types";
//import moment from "moment";

const INITIAL_STATE = {
    reports: false,
    reportTypes: false,
    reportKeys: false,
    requesting: false,
    month: false,
    toMonth: false,
    year: false,
    reportType: false,
    jobPackReports: false,
    template: false,
    specificTemplate: false,
    vehicleAlerts: false,
    downloads: false
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case GET_VEHICLE_ALERTS.REQUEST: {
            return { ...state, requesting: true, vehicleAlerts: false };
        }
        case GET_VEHICLE_ALERTS.FAIL: {
            return { ...state, requesting: false, vehicleAlerts: false };
        }
        case GET_VEHICLE_ALERTS.SUCCESS: {
            return { ...state, requesting: false, vehicleAlerts: action.payload };
        }
        case GET_ALL_REPORTS.REQUEST: {
            return { ...state, requesting: true, reports: false };
        }
        case GET_ALL_REPORTS.FAIL: {
            return { ...state, requesting: false, reports: false };
        }
        case GET_ALL_REPORTS.SUCCESS: {
            return { ...state, requesting: false, reports: action.payload };
        }
        case GET_JOBPACK_REPORTS.REQUEST: {
            return { ...state, requesting: true, jobPackReports: false };
        }
        case GET_JOBPACK_REPORTS.FAIL: {
            return { ...state, requesting: false, jobPackReports: false };
        }
        case GET_JOBPACK_REPORTS.SUCCESS: {
            return {
                ...state,
                requesting: false,
                jobPackReports: action.payload,
            };
        }
        case GET_REPORT_TYPES.REQUEST: {
            return { ...state, requesting: true, reportTypes: false };
        }
        case GET_REPORT_TYPES.FAIL: {
            return { ...state, requesting: false, reportTypes: false };
        }
        case GET_REPORT_TYPES.SUCCESS: {
            return { ...state, requesting: false, reportTypes: action.payload };
        }
        case SET_SPECIFIC_TEMPLATE.REQUEST: {
            return { ...state, requesting: true, specificTemplate: false };
        }
        case SET_SPECIFIC_TEMPLATE.FAIL: {
            return { ...state, requesting: false, specificTemplate: false };
        }
        case SET_SPECIFIC_TEMPLATE.SUCCESS: {
            return { ...state, requesting: false, specificTemplate: action.payload };
        }
        case GET_HSQE_TEMPLATE.REQUEST: {
            return { ...state, requesting: true, template: false };
        }
        case GET_HSQE_TEMPLATE.FAIL: {
            return { ...state, requesting: false, template: false };
        }
        case GET_HSQE_TEMPLATE.SUCCESS: {
            return { ...state, requesting: false, template: action.payload };
        }
        case GET_REPORT_KEYS.REQUEST: {
            return { ...state, requesting: true, reportKeys: false };
        }
        case GET_REPORT_KEYS.FAIL: {
            return { ...state, requesting: false, reportKeys: false };
        }
        case GET_REPORT_KEYS.SUCCESS: {
            return { ...state, requesting: false, reportKeys: action.payload };
        }
        case SET_MONTH: {
            return { ...state, month: action.payload };
        }
        case SET_TO_MONTH: {
            return { ...state, toMonth: action.payload };
        }
        case SET_YEAR: {
            return { ...state, year: action.payload };
        }
        case SET_REPORT_TYPE: {
            return { ...state, reportType: action.payload };
        }
        case GET_DOWNLOADS.REQUEST: {
            return { ...state, requesting: true, downloads: false };
        }
        case GET_DOWNLOADS.FAIL: {
            return { ...state, requesting: false, downloads: false };
        }
        case GET_DOWNLOADS.SUCCESS: {
            return { ...state, requesting: false, downloads: action.payload };
        }
        default: {
            return state;
        }
    }
};
